<template>
	<CDialog
		:visible="visible"
		:title="orgName + ' is currently on the ' + planLevel + ' plan.'"
		custom-class="dialog--tiny organization-settings-plan hipaa-unavailable-dialog"
		@done="$emit('close')"
	>
		{{ hipaaUnavailableDialogText }}
		<template #footer>
			<button class="c-modal-button c-modal-button-cancel button--secondary" @click="$emit('close')">
				Close
			</button>
		</template>
	</CDialog>
</template>

<script lang="ts">
	import { defineComponent } from 'vue';
	import CDialog from 'src/components/dialogs/Dialog.vue';

	export default defineComponent({
		name: 'CHipaaUnavailableDialog',
		components: {
			CDialog
		},
		props: {
			visible: { type: Boolean, default: false },
			isTrial: { type: Boolean, default: false },
			orgName: { type: String, default: '' },
			planLevel: { type: String, default: '' }
		},
		computed: {
			hipaaUnavailableDialogText() {
				let message = 'An Enterprise plan is required to enter into a Business Associate Agreement with Cognito Forms.';
				if (this.isTrial)
					message = this.orgName + ' is currently trialing the Enterprise plan. Please end the trial before establishing a Business Associate Agreement with Cognito Forms.';

				return message;
			}
		}
	});
</script>